/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.academy.catalog.rpc.TrackChirpService
 */

/**
 * Virtual record for map with known enum keys
 */

export const ExamTypename = 'com.hubspot.academy.core.models.content.Exam';
export const LinkAssetTypename = 'com.hubspot.academy.core.models.content.LinkAsset';
export const QuizAssetTypename = 'com.hubspot.academy.core.models.content.QuizAsset';
export const ChapterAssetTypename = 'com.hubspot.academy.core.models.content.chapter.ChapterAsset';
export const ExerciseAssetTypename = 'com.hubspot.academy.core.models.content.exercise.ExerciseAsset';
export const VideoAssetTypename = 'com.hubspot.academy.core.models.content.video.VideoAsset';
export const getHydratedTrackRpc = {
  serviceName: 'com.hubspot.academy.catalog.rpc.TrackChirpService',
  rpcName: 'getHydratedTrack',
  auth: 'app',
  fingerprint: 'YWKCFoaDalNMdm7DUjXvh--ymnNyhEw2',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};